import(/* webpackMode: "eager" */ "/app/node_modules/@payloadcms/richtext-lexical/dist/features/migrations/lexicalPluginToLexical/nodes/unknownConvertedNode/Component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@payloadcms/richtext-lexical/dist/features/migrations/slateToLexical/nodes/unknownConvertedNode/Component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["CarouselClient"] */ "/app/src/blocks/Carousel/Component.client.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/blocks/CategoryGrid/index.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["Code"] */ "/app/src/blocks/Code/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FormBlock"] */ "/app/src/blocks/Form/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/AnimatedFeatures/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeaturedProducts"] */ "/app/src/components/FeaturedProducts/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/app/src/components/Media/Image/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Video"] */ "/app/src/components/Media/Video/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Price.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Gallery"] */ "/app/src/components/product/Gallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductBanner","VariantBanner","BulkDiscountBanner","DiscountRibbon"] */ "/app/src/components/product/ProductBanners.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductDescription"] */ "/app/src/components/product/ProductDescription.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductSwipeNav"] */ "/app/src/components/product/ProductSwipeNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ShopByCategories/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/glass/glass.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["WishlistButton"] */ "/app/src/components/WishlistButton/index.tsx");
